import type { WorldPoint } from './canvas';

export function parseMetres(text: string): number | undefined {
  const normalized = text.trim().replace(',', '.');
  if (!normalized) return undefined;
  const value = Number(normalized);
  return Number.isFinite(value) ? value : undefined;
}

export function pointAtLength(anchor: WorldPoint, cursor: WorldPoint, lengthMetres: number): WorldPoint | undefined {
  if (!Number.isFinite(lengthMetres) || lengthMetres < 0) return undefined;
  const dx = cursor.x - anchor.x;
  const dy = cursor.y - anchor.y;
  const norm = Math.hypot(dx, dy);
  if (norm <= Number.EPSILON) return undefined;
  const lengthMillimetres = lengthMetres * 1000;
  return {
    x: anchor.x + (dx / norm) * lengthMillimetres,
    y: anchor.y + (dy / norm) * lengthMillimetres,
  };
}

export function pointAtOffsets(anchor: WorldPoint, xMetres: number, yMetres: number): WorldPoint | undefined {
  if (!Number.isFinite(xMetres) || !Number.isFinite(yMetres)) return undefined;
  return {
    x: anchor.x + xMetres * 1000,
    y: anchor.y + yMetres * 1000,
  };
}

export function formatDraftMetres(valueMillimetres: number): string {
  return `${(valueMillimetres / 1000).toFixed(3)} m`;
}

export function isDynamicNumericKey(key: string): boolean {
  return /^[0-9.,+-]$/.test(key);
}
